import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

export default function Tabs({ tabs }) {
  const location = useLocation();

  return (
    <div className="flex space-x-4" aria-label="Tabs">
      {tabs.map((tab) => {
        const isCurrent = location.pathname === tab.href;
        return (
          <Link
            key={tab.name}
            to={tab.href}
            className={classNames(
              isCurrent
                ? 'bg-indigo-400/10 text-indigo-400'
                : 'text-gray-400 hover:text-gray-200',
              'rounded-md px-3 py-2 text-sm font-medium'
            )}
            aria-current={isCurrent ? 'page' : undefined}
          >
            {tab.name}
          </Link>
        );
      })}
    </div>
  );
}
